'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  fullWidth?: boolean;
  yOffset?: number;
  xOffset?: number;
  duration?: number;
  scale?: number;
  ease?: number[] | string;
  priority?: boolean;
}

export default function FadeIn({
  children,
  delay = 0,
  className = "",
  direction = 'up',
  fullWidth = false,
  yOffset,
  xOffset,
  duration = 0.5,
  scale = 0.98,
  ease = [0.2, 0.0, 0, 1.0],
  priority = false
}: FadeInProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  const directionOffset = {
    up: { y: yOffset ?? 20, x: xOffset ?? 0 },
    down: { y: yOffset ?? -20, x: xOffset ?? 0 },
    left: { x: xOffset ?? 20, y: yOffset ?? 0 },
    right: { x: xOffset ?? -20, y: yOffset ?? 0 },
    none: { x: 0, y: 0 }
  };

  return (
    <motion.div
      ref={ref}
      initial={priority ? false : {
        opacity: 0,
        scale: scale,
        filter: 'blur(4px)',
        ...directionOffset[direction]
      }}
      animate={isInView || priority ? {
        opacity: 1,
        scale: 1,
        filter: 'blur(0px)',
        x: 0,
        y: 0
      } : {}}
      transition={{
        duration: duration,
        delay: delay,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ease: ease as any,
      }}

      className={className}
      style={{ width: fullWidth ? '100%' : 'auto' }}
    >
      {children}
    </motion.div>
  );
}
